import { xs_languageCode } from '..';
import { specialIncreasedBets } from "./data";
import { parseBetsData } from "./parseBetsData";
import { getUrlPath } from './util/getUrlPath';
import { addZero, formatDate, formatDateWithWeekDay, getSplitDesc } from "./utils";

function getCombinedRankingString(match) {
    const r = match.rankings;
    return `${r.sportRanking}_${r.categoryRanking}_${r.tournamentRanking}_${match.timestampDB}`;
}

function byRankingAndTimestamp(a, b) {
    const aRanking = getCombinedRankingString(a);
    const bRanking = getCombinedRankingString(b);
    return aRanking.localeCompare(bRanking);
}

export function parseExtraEvents(prematchData, data) {
    const matches = [];
    data.forEach(m => {
        const tournamentId = `${m.is}_${m.ic}_${m.it}`;
        const sport = prematchData.sportById[m.is];
        const category = sport.categoryById[m.ic];
        const tournament = prematchData.tournamentByUniqueId[tournamentId];

        if (tournament == null) {
            return;
        }

        const desc = m.dsl[xs_languageCode];
        const tournamentDesc = `${sport.descrizione} - ${category.descrizione} - ${tournament.descrizione}`;
        const sportId = m.is;
        const uniqueId = `${sportId}_${m.ic}_${m.it}_${m.bid}`;
        const matchData = {
            sportRef: sportId,
            pal: m.p,
            avv: m.a,
            id: m.bid,
            desc,
            uniqueId,
            alias: m.al,
            sportDesc: sport.descrizione,
            tournamentDesc,
            timestamp: m.ts,
            tournamentRef : m.it
        };
        const betsData = parseBetsData(matchData, [m.oa], m.oa, m.scs, false, true);
        const date = formatDate(m.ts);
        const [team1, team2] = getSplitDesc(desc);
        const match = {
            id: m.bid,
            alias: m.al,
            pal: m.p,
            avv: m.a,
            desc,
            team1,
            team2,
            date: `${addZero(date.day)}/${addZero(date.month)}`,
            fullDate: formatDateWithWeekDay(m.ts).dayMonthYear,
            time: formatDate(m.ts).time,
            timestampDB: m.ts,
            isLive: m.lv,
            sportRef: sportId,
            categoryRef: m.ic,
            sportDesc: matchData.sportDesc,
            tournamentDesc,
            // icoTournament : tournamentIcoById[m.it],
            tournamentRef: m.it,
            uniqueId,
            favorite: false,
            plus: m.pl,
            openAggregata: m.oa,
            openMacrogruppo: m.om,
            rankings: {
                sportRanking: sport.ranking,
                categoryRanking: category.ranking,
                tournamentRanking: tournament.ranking
            },
            urlPath: getUrlPath(tournament, m, desc)
        };
        Object.assign(match, betsData);
        
        matches.push(match);
    });

    matches.sort(byRankingAndTimestamp);

    // Group matches by sport and type
    let extra = new Map();
    let cota = new Map();
    matches.forEach(match => {
        const specialBet = specialIncreasedBets.getBet(match.bets[0].id, match.bets[0].handicap);
        const isExtra = specialBet && specialBet.extraOddsMarket;
        //const isSuper = specialBet && specialBet.superOddsMarket;
        const map = (isExtra? extra : cota);
        if (!map.has(match.sportRef)) {
            map.set(match.sportRef, []);
        }
        map.get(match.sportRef).push(match);
    });
    extra = Array.from(extra.values());
    cota = Array.from(cota.values());
    const all = cota.concat(extra);
    
    return {extra, cota, all, raw: data};
}
